document.addEventListener("DOMContentLoaded", function () {
    // Add active class to the first tab
    document.querySelector(".tabs li:first-child")?.classList.add("active");
    document.querySelector(".tabs-content li:first-child")?.classList.add("active");
  
    // Get all tab links
    const tabLinks = document.querySelectorAll(".tabs li a");
  
    tabLinks.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // prevent default anchor behavior
  
        const tabId = this.getAttribute("href");
  
        // Remove active class from all tabs and content
        document.querySelectorAll(".tabs li").forEach(function (tab) {
          tab.classList.remove("active");
        });
  
        document.querySelectorAll(".tabs-content li").forEach(function (content) {
          content.classList.remove("active");
        });
  
        // Add active class to the clicked tab and corresponding content
        this.parentElement.classList.add("active");
        const target = document.querySelector(tabId);
        if (target) {
          target.classList.add("active");
        }
      });
    });
  });
  